import { render, staticRenderFns } from "./si_fullLogo.vue?vue&type=template&id=86a032b8&scoped=true&"
import script from "./si_fullLogo.vue?vue&type=script&lang=js&"
export * from "./si_fullLogo.vue?vue&type=script&lang=js&"
import style0 from "./si_fullLogo.vue?vue&type=style&index=0&id=86a032b8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86a032b8",
  null
  
)

export default component.exports